module.exports = __webpack_public_path__ + "static/classhook-onboarding-before-976a1bbd501ea01643d8b53038883862.jpg";